import { RESOURCE_SERVER_HOST } from '@/config'
import {MIME_TYPES} from '@/config/file.js'

// 根据给定的大小B转换成MB等单位
export function formatSize(input) {
  if (input === undefined || input === '') {
    return ''
  }
  if (/\D/.test(input)) {
    return input
  }
  if (input < 1024) {
    input = input + 'B'
  } else if (input < 1024 * 1024) {
    input = (input / 1024).toFixed(1) + 'KB'
  } else if (input < 1024 * 1024 * 1024) {
    input = (input / (1024 * 1024)).toFixed(1) + 'MB'
  } else {
    input = (input / (1024 * 1024 * 1024)).toFixed(1) + 'GB'
  }
  return input
}


export function getFullPath(path, type) {
  if (!path) {
    return ''
  }
  const httpReg = /^(http|https)/
  const fileReg = /^(file|data:image|blob:)/
  if (path.indexOf('file:///') === 0) {
    path = path.replace('file:///', 'cdvfile://umooc_cordova/')
  } else if(!httpReg.test(path) && !fileReg.test(path)) {
    if (path.charAt(0) === '/') {
      path = `${RESOURCE_SERVER_HOST}${path}`
    } else {
      path = `${RESOURCE_SERVER_HOST}/${path}`
    }
  }
  return path
}

export function fileType (path) {
  let type = 'other'
  if (!path) {
    return type
  }
  let ext = path.substring(path.lastIndexOf('.') + 1).toLowerCase()
  for (let key in MIME_TYPES) {
    let item = MIME_TYPES[key]
    if (MIME_TYPES[key].includes(ext)) {
      type = key
      break
    }
  }
  return type
}
export function fileIcon(path) {
  let icon = "icon-fujianleixingqita1";
  if (!path) {
    return icon
  }
  
  let ext = path.substring(path.lastIndexOf('.') + 1).toLowerCase()
  var type = 'other'
  for (let key in MIME_TYPES) {
    let item = MIME_TYPES[key]
    if (MIME_TYPES[key].includes(ext)) {
      type = key
      break
    }
  }
  switch (type) {
    case 'document':
      switch (ext) {
        case "txt":
          icon = "icon-fujianleixingtxt";
          break;
        case "pdf":
          icon = "icon-fujianleixingpdf";
          break;
        case "doc":
          icon = "icon-fujianleixingword";
          break;
        case "docx":
          icon = "icon-fujianleixingword";
          break;
        case "ppt":
          icon = "icon-fujianleixingppt";
          break;
        case "pptx":
          icon = "icon-fujianleixingppt";
          break;
        case "xls":
          icon = "icon-fujianleixingexcel";
          break;
        case "xlsx":
          icon = "icon-fujianleixingexcel";
          break;
        default:
          icon = "icon-fujianleixingqita1";
      }
      break;
    case 'image':
      icon = "icon-fujianleixingtupian";
      break;
    case 'video':
      icon = "icon-fujianleixingshipin";
      break;
    case 'audio':
      icon = "icon-fujianleixingyinpin";
      break;
    case 'zip':
      icon = "icon-fujianleixingyasuobao";
      break;
    case 'other':
      icon = "icon-fujianleixingqita1";
      break;
    default:
  }
  return icon;
}

// 根据文件的扩展名或文件名 给出文件的类型
export function formatFileType(suffix) {
  if (!suffix) {
    return 'other'
  }
  if (suffix.split('?')[0]) {
    suffix = suffix.split('?')[0]
  }
  suffix = suffix.substring(suffix.lastIndexOf('.') + 1).toLowerCase()
  var fileTypes = {
    video: {
      format: 'mp4,avi,wmv,rm,rmvb,mpeg,mpg,mkv,mov,flv',
      type: 'video'
    },
    audio: {
      format: 'mp3,wav,wma',
      type: 'audio'
    },
    image: {
      format: 'png,jpg,gif,jpeg,bmp',
      type: 'image'
    },
    document: {
      format: 'doc,docx,xls,xlsx,ppt,pptx,pdf,txt',
      type: 'document'
    },
    zip: {
      format: 'zip,rar',
      type: 'zip'
    },
    flash: {
      format: 'swf',
      type: 'flash'
    },
    srt: {
      format: 'srt',
      type: 'srt'
    }
  }
  let type = 'other'
  let fileType
  for (fileType in fileTypes) {
    var limit = fileTypes[fileType].format
    if (limit.indexOf(suffix) >= 0) {
      type = fileTypes[fileType].type
      return type
    }
  }
  return type
}